import { IPreloadedState } from 'shared/types/redux';

export const selectIsGeoModalOpen = (state: IPreloadedState) => state.geo.isModalOpen;
